import React from "react";
import Header from "@/components/jp/Header";
import Menu from "@/components/jp/Menu";
import Footer from "@/components/jp/Footer";
import FloatingButton from "@/components/jp/FloatingButton";
import ScrollToTopFab from "@/components/jp/ScrollToTopFab";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";

import SAbout from "@/public/static/images/opacity_about.png";
import SComNet from "@/public/static/images/opacity_company_network.png";
import SContact from "@/public/static/images/opacity_contact.png";

const breadcrumbs = [
  <Link key="1" href="/jp/">
    Home
  </Link>,
  <Typography key="2">Cookies Details Page</Typography>,
];

function cookie() {
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  Cookies Details Page
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">What are Cookies?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  Cookies are small data files. When you visit a website, the
                  website sends the cookie to your computer. Your computer
                  stores it in a file located inside your web browser.
                </p>
                <p className="mb-3">
                  Cookies do not transfer viruses or malware to your computer
                  because the data in a cookie does not change when it travels
                  back and forth, it has no way to affect how your computer
                  runs, but they act more like logs (i.e. they record user
                  activity and remember stateful information) and they get
                  updated every time you visit a website.
                </p>
                <p className="mb-3">
                  We may obtain information about you by accessing cookies, sent
                  by ZENIYA website. Different types of cookies keep track of
                  different activities. For example, session cookies are used
                  only when a person is actively navigating a website. Once you
                  leave the website, the session cookie disappears.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Why are cookies useful?</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  ZENIYA website uses functional cookies to analyses how
                  visitors use our website, track and improve our website&apos;s
                  functions and performance. The activity allows us to provide a
                  good customer experience to visitor by identifying and fixing
                  any issues that may happen, such as using cookies to keep
                  track of which website pages are most popular and which method
                  of linking between website pages is most effective. The latter
                  also helps us to track if you were referred to us by another
                  website and improve our future advertising activities.
                </p>
                <p className="mb-3">
                  Another use of cookies is to store your log in sessions. If
                  website has log in function, when you log in to the Members
                  Area, a &quot;session cookie&quot; is set so that the website
                  remembers that you have already logged in. If the website did
                  not set this cookie, you will be asked for your login and
                  password on each new page as you progress through website.
                </p>
                <p className="mb-3">
                  In addition, functional cookies, for example, are used to
                  allow us to remember your preferences and identify you as a
                  user, ensure your information is secure and operate more
                  reliably and efficiently. For example, cookies save you the
                  trouble of typing in your username every time you access our
                  website, and recall your preferences, such as which language
                  you wish to see when you log in.
                </p>
                <p className="mb-3">Our cookies provides us the following :</p>
                <ul className="mb-3">
                  <li className="mb-1">
                    Detecting the country you are currently visiting from
                  </li>
                  <li className="mb-1">Checking browser type and device</li>
                  <li className="mb-1">
                    Tracking which site the user was referred from
                  </li>
                  <li className="mb-1">
                    Allowing third parties to customize content accordingly
                  </li>
                </ul>
                <p className="mb-3">
                  ZENIYA website uses Google Analytics, a web analytics service
                  provided by Google, Inc.. Google Analytics uses analytical
                  cookies placed on your computer, to help us analyze a
                  user&apos;s use of the website. The information generated by
                  the cookie about your website usage (including your IP
                  address) may be transmitted to Google, Inc. and stored on
                  their servers. Google, Inc. may use this information to
                  evaluate your website usage, to make reports about website
                  activity and to provide other services related to website
                  activity and internet usage. Google, Inc. may also transfer
                  this information to third parties, where required to do so by
                  law, or where such third parties process the information on
                  behalf of Google. Google, Inc. will not associate your IP
                  address with any other data held. By using ZENIYA website, you
                  give your consent to Google, Inc. to process data about you in
                  the manner and for the purposes set out above.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">
                  Type of Cookies that might be stored on your device
                </h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <h4 className="mb-2">Functional cookies</h4>
                <p className="mb-5">
                  These cookies are necessary to performing the best performance
                  of our website. Without these cookies our websites would not
                  function properly. These cookies allow a website to remember
                  choices you have made in the past such as the language you
                  prefer, your user name and password in case the website need
                  logging in, you can automatically log in etc..
                </p>
              </div>

              <div className="text-box">
                <h4 className="mb-2">Analytical cookies</h4>
                <p className="mb-5">
                  Analytical cookies are important in measuring the performance
                  of a website and optimizing it. These cookies are information
                  about visitors&apos; behavior on a webpage during a visit. It
                  used to determine website usage and may be used to track an
                  individual users, but only to the extent to allow users
                  journey through the site. Analytical cookies collect
                  statistical, not personal information to help improving
                  website performance, user experience or speed of the page.
                </p>
              </div>

              <div className="text-box">
                <h4 className="mb-2">Marketing cookies</h4>
                <p className="mb-5">
                  These cookies are used to track visitors across websites for
                  the purpose of delivering advertising that is relevant to the
                  individual user and displaying advertising that is more
                  valuable for publishers and third party advertisers.
                </p>
              </div>

              <div className="text-box">
                <h4 className="mb-2">Targeting Cookies</h4>
                <p className="mb-5">
                  These cookies are used to deliver the content which best suits
                  you and your interests. Targeting Cookies can be used for
                  targeting advertisement, limiting ad delivering or measuring
                  promotional campaign effectiveness.
                </p>
              </div>

              <div className="text-box">
                <h4 className="mb-2">Preferences cookies</h4>
                <p className="mb-5">
                  Preference cookies enable a website to remember information
                  that changes the way the website behaves or looks, like your
                  preferred language or the region that you are in.
                </p>
              </div>

              <div className="text-box">
                <h4 className="mb-2">Session cookies</h4>
                <p className="mb-5">
                  These cookies are used only when a person is actively
                  navigating a website. Once you leave the website, the session
                  cookie disappears.
                </p>
              </div>
            </div>

            <div className="col-12 py-2">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Disabling Cookies</h5>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="text-box">
                <p className="mb-3">
                  Cookies are small data files that can be used by websites to
                  make a user&apos;s experience more efficient. The law states
                  that we can store cookies on your device if they are strictly
                  necessary for the operation of this site. For all other types
                  of cookies we need your permission. This site uses different
                  types of cookies. Some cookies are placed by third party
                  services that appear on our pages.
                </p>
                <p className="mb-3">
                  Most of web browsers are set up to accept cookies. You may be
                  able to set your browser to warn you before accepting certain
                  cookies or to refuse certain cookies. However, if you disable
                  the use of cookies in your web browser, some services and
                  functions of ZENIYA website may be difficult to be used or may
                  not function correctly, and you may have to manually adjust
                  some preferences every time you visit our website. We use
                  cookies to optimize your user experience on our website. For a
                  full website experience, please accept our cookies policy.
                </p>
                <p className="mb-3">
                  To find out about how to disable cookies, please refer to the
                  following.
                </p>
                <Link
                  href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                >
                  IE
                  [https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies]
                </Link>
                <Link
                  href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en"
                  target="_blank"
                >
                  Chrome
                  [https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en]
                </Link>
                <Link
                  href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                  target="_blank"
                >
                  Firefox
                  [https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences]
                </Link>
                <p className="mb-3">
                  You can at any time change or withdraw your consent from the
                  Cookie Declaration on our website
                </p>
                <p>
                  Learn more about how to use this website in our Terms and
                  Conditions and how we process personal data in our{" "}
                  <Link href="/privacypolicy">Privacy Policy.</Link>
                </p>
                <p>
                  Your consent applies to the following domains :
                  <Link href="/">https://www.zeniya-thai.com/</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">会社概要</h1>
                </div>
              </div>
            </Link>
            <Link href="/companynetwork">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SComNet}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">関連会社紹介</h1>
                </div>
              </div>
            </Link>
            <Link href="/contactus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SContact}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">お問い合わせ</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>

      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export default cookie;
